import { cn } from "@app/lib/utils";
import { trans } from "@mongez/localization";
import { useTabConfiguration, useTabNavigation, useTabScroll } from "./hooks";
import { TabKey } from "./types";

interface NavigationTabsProps {
  activeTab: TabKey;
}

export function NavigationTabs({ activeTab }: NavigationTabsProps) {
  const { navigateToTab } = useTabNavigation();
  const { tabs } = useTabConfiguration(activeTab);
  const { tabsContainerRef, activeTabRef } = useTabScroll(activeTab);

  const handleTabClick = (tabValue: TabKey, event: React.MouseEvent) => {
    navigateToTab(tabValue, event);
  };

  return (
    <div className="sticky top-[88px] z-40 mb-16 min-w-full bg-[#F7F9FC] py-3 shadow-sm md:mb-10 lg:top-[120px] 3xl:mb-12">
      {/* Mobile: Horizontal scroll for tabs */}
      <div
        ref={tabsContainerRef}
        className="container flex gap-2 overflow-x-auto sm:gap-3 md:gap-4 md:no-scrollbar 3xl:gap-6"
      >
        <div className="flex min-w-max gap-2 sm:gap-3 md:gap-4 lg:min-w-0 xl:flex-wrap 3xl:gap-6">
          {tabs.map((tab) => (
            <button
              key={tab.labelKey}
              ref={tab.isActive ? activeTabRef : undefined}
              onClick={(e) => handleTabClick(tab.value, e)}
              className={cn(
                "flex-shrink-0 cursor-pointer whitespace-nowrap rounded-full px-3 py-2 text-sm font-semibold transition-all duration-300 ease-in-out sm:px-4 sm:text-base md:px-6 md:text-lg lg:text-xl 3xl:px-8 3xl:text-2xl",
                tab.isActive
                  ? "border-2 border-bright-orange bg-transparent text-bright-orange"
                  : "bg-gray-100 text-marine hover:bg-gray-200 hover:shadow-sm",
              )}
            >
              <span className="block ltr:mt-1">{trans(tab.labelKey)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
